<script setup lang="ts">
import { AppStars, AppMarkdownWrapper } from '@libs/ui';

import type { ActivityDetailsMainData } from '../models/activityDetailsMain';

interface ActivityDetailsMainProps {
  mainInfo: ActivityDetailsMainData;
}
const props = defineProps<ActivityDetailsMainProps>();
</script>

<template>
  <div class="activity-details-main">
    <span class="activity-name">{{ props.mainInfo.activityName }}</span>
    <span class="activity-destination">
      {{ props.mainInfo.fullDestination }}
    </span>
    <AppStars
      v-if="props.mainInfo.rating"
      :amount="props.mainInfo.rating"
      size="24"
    />
    <span v-if="props.mainInfo.mainDescription" class="activity-description">
      <AppMarkdownWrapper :source="props.mainInfo.mainDescription" />
    </span>
  </div>
</template>

<style scoped lang="scss">
.activity-details-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--spacin-4);
  .activity-name {
    @include font-heading-3;
    @include for-less-or-equal-than-900-px {
      @include font-heading-5;
      max-width: 340px;
    }
  }
  .activity-destination {
    @include font-body-l-light;
    @include for-less-or-equal-than-900-px {
      @include font-body-m-light;
    }
  }
  .activity-description {
    margin-top: var(--spacing--8);
    @include font-body-m-light;
    @include for-less-or-equal-than-900-px {
      @include font-body-s-light;
    }
  }
}
</style>
